module.exports = __webpack_public_path__ + "img/Girl_010006.8bee8281.png";